import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-line bg-ink-800 py-12" data-id="element-177" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto max-w-4xl px-5 text-center md:px-8" data-id="element-178" data-mp="3r7zpbqhiqwdd">
        <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-white" data-id="element-179" data-mp="3mhj7zvakuqlq">
          Baseball 360™
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-slate-400" data-id="element-180" data-mp="3hheqq31uhrug">
          The #1 complete system for youth baseball coaches worldwide. Because coaching shouldn't
          cost you every evening of the week.
        </p>
        <p className="mt-6 text-sm text-slate-300" data-id="element-181" data-mp="38jun4ngifjgo">
          📧 support@baseball360.com · 📲 @baseball360coach · 🌐 www.baseball360.com
        </p>
        <p className="mt-8 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500" data-id="element-182" data-mp="2ykdkkewk1lox">
          © Baseball 360™ 2025 — All rights reserved.
        </p>
      </div>
    </footer>;
}